// extracted by mini-css-extract-plugin
module.exports = {"Game":"NoqlL5TyfEl3SnRO4QoQ-","nameField":"_1piG38pHGAmlQHd7GV3cUt"};